const deepChangeId = (flow, forceMode = false) => {
    let returnRoot = false;
    if(!Array.isArray(flow)) {
       flow = [flow];
       returnRoot = true;
    }
    for (let h = 0; h < flow.length; h += 1) {
      if (forceMode || flow[h].id === undefined || !flow[h].id || flow[h].id === "") {
        let m = new Date();
        m.setMonth(m.getMonth() + Math.floor(Math.random() * 2) + 100);
        flow[h].id =
          String(Math.floor(Math.random() * 2000)) +
          String(m.getTime() + Math.floor(Math.random() * 2) + 10000) +
          h;
      }
      if (flow[h].children)
        for (let i = 0; i < flow[h].children.length; i += 1)
          flow[h].children[i].data = deepChangeId(
            flow[h].children[i].data, forceMode
          );
    }
    
    return !returnRoot?flow:flow[0];
  };

  export { deepChangeId }